/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import React, {  useEffect, useState } from 'react'
import CustomTooltip from '../CustomTooltip/CustomTooltip'
import moment from 'moment'
import { Divider } from '@mui/material'
import { useNavigate } from 'react-router-dom';
import type { appConfigs } from '../types/types'
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import { ViewStrokeRounded, Image03Icon } from '@hugeicons-pro/core-stroke-rounded';
import OutlineButton from '../MUICustomButton/OutlineButton';
import TemplatePreview from '../TemplatePreview/TemplatePreview';
import {RESENDTOOPTIONS, BULKCAMPAIGNSUCCESS, BULK_UNSUBSCRIBE_LEVELS, PRIORITY_OPTIONS } from 'src/constants/constant';
import CustomDataTable from '../CustomDataTable/CustomDataTable';
import type { TableColumn } from 'react-data-table-component';

interface BulkEmailSummaryProps {
  bulkEmailData: any;
  campaignData:any;
  estimatedEndDate?: string;
  totalRecipientCount?: number;
  seedDataCount?: number;
  suppressedCount?: number;
}

  const getSendOrderLabel = (index: number): string => {
    const labels = [
      'Initial', 'Resend 1', 'Resend 2', 'Resend 3', 'Resend 4',
      'Resend 5', 'Resend 6', 'Resend 7', 'Resend 8', 'Resend 9', 'Resend 10'
    ];
    return labels[index] || `Resend ${index}`;
  };

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function BulkEmailSummary({ bulkEmailData,campaignData, suppressedCount: suppressedCountProp, seedDataCount: seedDataCountProp, totalRecipientCount: totalRecipientCountProp, }: BulkEmailSummaryProps): JSX.Element {

    // const [isLoading, setIsLoading] = useState<boolean>(false)
    const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
    const [imageError, setImageError] = useState(false);
    const storedAppConfig = localStorage.getItem("appConfigs");
    const parsedAppConfig = storedAppConfig
        ? (JSON.parse(storedAppConfig) as appConfigs[])
        : []; // Default to an empty array if null

    const TemplateImagePublicURL = parsedAppConfig.find(
        (item) => item.configName === "TemplateImagePublicURL"
    )?.configValue;

    const suppressedCount = suppressedCountProp;
    const seedCount = seedDataCountProp;
    const totalRecipientCount = totalRecipientCountProp;

    const scheduleColumns: TableColumn<any>[] = [
      {
        name: 'Send',
        selector: (_row, index) => index ?? 0,
        width: '25%',
        cell: (_row, index) => (
          <span className="text-14 text-gray-800 font-medium">
            {getSendOrderLabel(index ?? 0)}
          </span>
        ),
        sortable: false,
      },
      {
        name: 'Date & Time',
        selector: (row: any) => row.dateTime,
        width: '45%',
        cell: (row: any) => (
          <span className="text-14 text-gray-700">
            {row.dateTime ? moment(row.dateTime).format('MM/DD/YYYY hh:mm A') : 'N/A'}
          </span>
        ),
        sortable: false,
      },
      {
        name: 'Recipients',
        selector: (row: any) => row.recipients,
        width: '30%',
        cell: (row: any) => (
          <span className="text-14 text-gray-700">{row.recipients}</span>
        ),
        sortable: false,
      },
    ];

  
    const navigate = useNavigate()

    const handleBackClick = (): void => {
        navigate('/bulk-email')
    }

    console.log('BulkEmailSummary received data:', bulkEmailData);
    
    // ✅ Use the transformed data directly (no need for nested access)
    const campaign = bulkEmailData ?? {};
    console.log('Campaign data:', campaign);
    const scheduleData: any[] = [];

    if (campaign.bulkCampaignStartDate) {
      scheduleData.push({
        dateTime: campaign.bulkCampaignStartDate,
        recipients: 'All recipients',
      });
    }

    campaign.resendDateTimeLst?.forEach((schedule: any) => {
      const matchedOption = RESENDTOOPTIONS.find(
        (opt) => String(opt.value) === String(schedule.resendType)
      );
      scheduleData.push({
        dateTime: schedule.resendDateTime,
        recipients: matchedOption ? matchedOption.label : 'N/A',
      });
    });

     const user = JSON.parse(localStorage.getItem('user') ?? '{}');
     console.log(user);
    useEffect(() => {
      setImageError(false);
    }, [campaign?.templateIdentifier]);
    const buildTemplateImageUrl = (
  baseUrl: string | undefined,
  identifier?: string,
  version?: string
): string | undefined => {
  
  if (!baseUrl || !identifier || !version) return undefined;  // 👈 this guard is failing
  const trimmed = baseUrl.endsWith("/") ? baseUrl.slice(0, -1) : baseUrl;
  return `${trimmed}/Template/${identifier}/${version}/Template_Large.png`;
};

  const imageUrl = buildTemplateImageUrl(
    TemplateImagePublicURL,
    campaignData?.templateIdentifier,
    campaignData?.templateVersion
  );
    return (
        <>
      <div className="bg-white w-full">
        {/* Top Section: SVG Image and Text */}
        <div className="flex justify-center items-center flex-col py-4 bg-gray-50">
          <svg
            height="70px"
            width="70px"
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 32 32"
            xmlSpace="preserve"
            fill="#000000"
            className="mb-2"
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
              <g>
                <g id="check_x5F_alt">
                  <path
                    style={{ fill: '#38b120' }}
                    d="M16,0C7.164,0,0,7.164,0,16s7.164,16,16,16s16-7.164,16-16S24.836,0,16,0z M13.52,23.383 L6.158,16.02l2.828-2.828l4.533,4.535l9.617-9.617l2.828,2.828L13.52,23.383z"
                  ></path>
                </g>
              </g>
            </g>
          </svg>
          <p className="font-semibold text-muted text-[1.5rem] mt-2">{BULKCAMPAIGNSUCCESS}</p>
        </div>

        {/* Bottom Section: Split into Left (Summary) and Right (Template Preview) */}
        <div className="flex w-full"> {/* Reduced margin and border placement */}
          {/* ✅ Left Section: Summary */}
          <div className="w-1/2 pr-[20px]">
            <div className="mb-[10px] relative"> 
              <div className="bg-[#f5f5f5] text-center text-16 font-semibold rounded-full p-[4px] text-muted w-full">
                Summary
              </div>
            </div>

            <div className="">                                                       
              <div className="flex mb-[15px]">
                <span className="text-muted font-semibold w-1/2 text-[14px]">Campaign Name</span>
                <CustomTooltip title={campaign.bulkCampaignName} placement='bottom' arrow={false}>
                  <span className="text-muted w-1/2 truncate">{campaign.bulkCampaignName}</span>
                </CustomTooltip>
              </div>
              <div className="flex mb-[15px]">
                <span className="text-muted font-semibold w-1/2 text-[14px]">Email Template</span>
                <CustomTooltip title={campaign.templateName} placement='bottom' arrow={false}>
                  <span className="text-muted w-1/2 truncate">{campaign.templateName}</span>
                </CustomTooltip>
              </div>
              {bulkEmailData.seedListName && (
                  <div className="flex mb-[15px]">
                      <span className="text-muted font-semibold w-1/2 text-[14px]">Seed List</span>
                      <CustomTooltip title={bulkEmailData.seedListName} placement="bottom" arrow={false}>
                          <span className="text-muted w-1/2">
                              {bulkEmailData.seedListName.length > 30
                                  ? bulkEmailData.seedListName.substring(0, 30) + "..."
                                  : bulkEmailData.seedListName}
                          </span>
                      </CustomTooltip>
                  </div>
              )}
                            
              {/* ✅ Added Suppression List Name */}
              {bulkEmailData.suppressionListName && (
                  <div className="flex mb-[15px]">
                      <span className="text-muted font-semibold w-1/2 text-[14px]">Suppression List</span>
                      <CustomTooltip title={bulkEmailData.suppressionListName} placement="bottom" arrow={false}>
                          <span className="text-muted w-1/2">
                              {bulkEmailData.suppressionListName.length > 30
                                  ? bulkEmailData.suppressionListName.substring(0, 30) + "..."
                                  : bulkEmailData.suppressionListName}
                          </span>
                      </CustomTooltip>
                  </div>
              )}
              {/* <div className="flex mb-[15px]">
                  <span className="text-muted font-semibold w-1/2 text-[14px]">Unsubscribe Level</span>
                  {(() => {const matchedPriority = BULK_UNSUBSCRIBE_LEVELS.find( (opt) => opt.value === String(campaign.unsubscribeTypeId) );
                      return (
                      <CustomTooltip title={matchedPriority?.label ?? ""} placement="bottom" arrow={false}>
                          <span className="text-muted w-1/2 truncate">
                          {matchedPriority ? matchedPriority.label : ""}
                          </span>
                      </CustomTooltip>
                      );
                  })()}
              </div> */}
              <div className="flex mb-[15px]">
                  <span className="text-muted font-semibold w-1/2 text-[14px]">Priority</span>
                  {(() => {const matchedPriority = PRIORITY_OPTIONS.find( (opt) => opt.value === String(campaign.priority) );
                      return (
                      <CustomTooltip title={matchedPriority?.label ?? ""} placement="bottom" arrow={false}>
                          <span className="text-muted w-1/2 truncate">
                          {matchedPriority ? matchedPriority.label : ""}
                          </span>
                      </CustomTooltip>
                      );
                  })()}
              </div>
              <div className="flex mb-[15px]">
                  <span className="text-muted font-semibold w-1/2 text-[14px]">Suppressed Count</span>
                  <span className="text-muted w-1/2">{suppressedCount}</span>
              </div>
              <div className="flex mb-[15px]">
                  <span className="text-muted font-semibold w-1/2 text-[14px]">Seed Count</span>
                  <span className="text-muted w-1/2">{seedCount}</span>
              </div>
              <div className="flex mb-[15px]">
                  <span className="text-muted font-semibold w-1/2 text-[14px]">Total Recipients</span>
                  <span className="text-muted w-1/2">{totalRecipientCount}</span>
              </div>
              {/* ✅ Campaign Schedule Table */}
              {scheduleData.length > 0 && (
                <div className="mt-6">
                  <p className="text-15 font-semibold text-muted mb-2">Campaign Schedule</p>
                  <div className="csv-data mb-4 mb-4 border rounded-lg bg-white flex flex-col max-h-[400px] p-2" style={{ borderColor: '#E6ECF2' }}>
                    <CustomDataTable
                      columns={scheduleColumns}
                      data={scheduleData}
                      pagination={false}
                    />
                  </div>
                </div>
              )}                                  
            </div>
          </div>

          {/* ✅ Right Section: Template Preview */}
          <div className="w-1/2 pl-[20px] flex flex-col items-start">
  <p className="text-16 font-semibold text-muted mb-2">Template Preview</p>
  <div className="h-[350px] flex items-center justify-center relative w-full border border-[#e6ecf2] rounded-lg">
   
 {campaignData?.templateIdentifier ? (
  <>
  {imageUrl && !imageError ? (
            <img
              src={imageUrl}
              alt="Template Preview"
              className="icon-hover"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "8px",
              }}
              onError={() => setImageError(true)}
            />
          ) : (
            <HugeiconsIcon icon={Image03Icon} size={50} color="#6B7280" />
          )}
  </>
) : (
  <div className="w-full h-full flex items-center justify-center bg-gray-50 rounded-lg">
    <HugeiconsIcon icon={Image03Icon} size={50} color="#6B7280" />
  </div>
)}
    {/* Hover View Icon */}
    <div className={`absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 opacity-0 rounded-lg ${campaign?.templateIdentifier ? 'hover:opacity-100 transition-opacity cursor-pointer' : ''}`} onClick={campaign?.templateContent ? () => setIsPreviewModalOpen(true) : undefined}>
      <HugeiconsIcon
        icon={ViewStrokeRounded}
        size={24}
        color="currentcolor"
        strokeWidth={0.5}
        className={`cursor-pointer text-white ${campaign?.templateContent !== undefined && campaign?.templateContent !== null && campaign?.templateContent !== ''
            ? ''
            : 'opacity-50 cursor-not-allowed'
          }`}
        onClick={campaign?.templateContent ? () => setIsPreviewModalOpen(true) : undefined}
      />
    </div>
  </div>
  
  {/* Created info moved here - directly below the thumbnail */}
  <div className="text-sm text-gray-700 mt-3">
    <span className="font-semibold text-muted" style={{ fontSize: '14px' }}>Created:</span>
    <span className="font-normal text-muted" style={{ fontSize: '14px' }}> {moment(campaign.createdOn).format('MM/DD/YYYY h:mmA')}<span style={{ fontStyle: "italic" }}> ({campaign?.createdUser})
      </span></span>
  </div>

  <TemplatePreview
    isOpen={isPreviewModalOpen}
    onClose={() => setIsPreviewModalOpen(false)}
    content={campaign?.templateContent ?? ''}
  />
</div>
 
          
          
        </div>
          
      </div>
      
      <div className="bg-white">
        {/* Gray Horizontal Line */}
        <Divider sx={{ color: '#D9D9D9', marginBottom: '30px', marginTop: '30px' }} />

        <div className="flex justify-end py-2 mt-2 pr-4">
          <OutlineButton onClick={handleBackClick} type='rounded' color='red' width='250px'>
            Bulk Email Overview
          </OutlineButton>
        </div>
      </div>
    </>
    )
}

export default BulkEmailSummary